import React from 'react';
import PropTypes from 'prop-types';

const CCustosRow = (props) => {
    return (
        <tr>
            <td className="row">
                <h5><span className="badge badge-dark"><i className={`fas fa-${props.ccusto.codigo_icone}`} /></span></h5>
                {" " + props.ccusto.nome}
            </td>
            <td>
                <i className="fas fa-edit" style={{ cursor: "pointer" }}
                    onClick={() => props.handleUpdate(props.ccusto)} />
                {" | "}
                <i className="far fa-trash-alt" style={{ cursor: "pointer" }}
                    onClick={() => props.handleDelete(props.ccusto.id)} />
            </td>
        </tr>
    );
};

CCustosRow.propTypes = {
    ccusto: PropTypes.object.isRequired,
    handleDelete: PropTypes.func.isRequired,
    handleUpdate: PropTypes.func.isRequired,
};

export default CCustosRow;


// WEBPACK FOOTER //
// ./src/components/ccustos/CCustosRow.js